import React from 'react';
import { hebergements } from '../data/mock';
import { Link } from 'react-router-dom';
import { ArrowRight, Star, Phone, MapPin } from 'lucide-react';

const Hebergements = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1920&q=80)' }}
        >
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Nos Hébergements</h1>
          <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
            Deux solutions d'accueil adaptées à vos besoins : gîte d'étape pour randonneurs et camping pour groupes de jeunes
          </p>
        </div>
      </section>

      {/* La Draille */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl order-2 lg:order-1">
              <img 
                src={hebergements.draille.images[0]} 
                alt={hebergements.draille.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="order-1 lg:order-2">
              <div className="flex items-center gap-3 mb-4">
                <div className="flex items-center gap-1">
                  {[...Array(3)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-[#afab53] text-[#afab53]" />
                  ))}
                </div>
                <span className="text-sm text-gray-600">{hebergements.draille.classification}</span>
              </div>
              <h2 className="text-4xl font-bold mb-4 text-gray-900">{hebergements.draille.name}</h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                {hebergements.draille.description}
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-[#afab53] flex-shrink-0 mt-1" />
                  <span className="text-gray-700">{hebergements.draille.location}</span>
                </div>
                <div className="flex items-start gap-3">
                  <Phone className="w-5 h-5 text-[#afab53] flex-shrink-0 mt-1" />
                  <div className="text-gray-700">
                    <p>{hebergements.draille.phone}</p>
                    <p>{hebergements.draille.mobile}</p>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 mb-8">
                <h3 className="font-semibold mb-4 text-gray-900">Services proposés</h3>
                <ul className="grid md:grid-cols-2 gap-3">
                  {hebergements.draille.services.map((service, index) => (
                    <li key={index} className="flex items-start gap-2 text-sm">
                      <span className="text-[#afab53] mt-1">✓</span>
                      <span className="text-gray-700">{service}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <Link to="/hebergements/gite-la-draille">
                <button className="inline-flex items-center gap-2 bg-[#afab53] hover:bg-[#9a9648] text-white px-6 py-3 rounded-lg font-semibold transition-all group">
                  <span>En savoir plus</span>
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* La Pègue */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block bg-[#afab53] text-white text-sm px-4 py-1 rounded-full mb-4">
                {hebergements.pegue.classification}
              </div>
              <h2 className="text-4xl font-bold mb-4 text-gray-900">{hebergements.pegue.name}</h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                {hebergements.pegue.description}
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-[#afab53] flex-shrink-0 mt-1" />
                  <span className="text-gray-700">{hebergements.pegue.location}</span>
                </div>
                <div className="flex items-start gap-3">
                  <Phone className="w-5 h-5 text-[#afab53] flex-shrink-0 mt-1" />
                  <span className="text-gray-700">{hebergements.pegue.phone}</span>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 mb-8 shadow-sm">
                <h3 className="font-semibold mb-4 text-gray-900">Services proposés</h3>
                <ul className="grid md:grid-cols-2 gap-3">
                  {hebergements.pegue.services.map((service, index) => (
                    <li key={index} className="flex items-start gap-2 text-sm">
                      <span className="text-[#afab53] mt-1">✓</span>
                      <span className="text-gray-700">{service}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <Link to="/hebergements/camping-la-pegue">
                <button className="inline-flex items-center gap-2 bg-[#afab53] hover:bg-[#9a9648] text-white px-6 py-3 rounded-lg font-semibold transition-all group">
                  <span>En savoir plus</span>
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </button>
              </Link>
            </div>
            <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src={hebergements.pegue.images[0]} 
                alt={hebergements.pegue.name}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 bg-gradient-to-br from-[#afab53] to-[#8a8742]">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">Besoin d'un hébergement ?</h2>
          <p className="text-xl mb-10 text-white/90">
            Contactez-nous pour vérifier les disponibilités et réserver votre séjour.
          </p>
          <Link to="/contact?category=draille">
            <button className="bg-white text-[#afab53] hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold text-lg transition-colors">
              Demander un devis
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Hebergements;